<form autocomplete="off" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-sm-6 offset-sm-3">
      <div class="card">
        <div class="card-header">
          <strong>Login</strong>
        </div>
        <div class="card-body">

          <div class="row" *ngIf="msgErroLogin">
            <div class="col-sm-12">
              <div class="alert alert-danger" role="alert">
                {{msgErroLogin}}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="cpf">CPF</label>
                <input type="text" 
                       class="form-control"
                       name="cpf"
                       id="cpf"
                       placeholder="Digite o seu CPF" 
                       formControlName="cpf" [textMask]="maskCPF">
             
                <div *ngFor="let error of formErrors.cpf" class="alert alert-danger">
                  {{ error }}
                </div>
                
              </div>
            </div>
          </div>
          <!--/.row-->
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="senha">Senha</label>
                <input type="password" autocomplete="new-password" class="form-control" id="senha" name="senha" placeholder="Digite a sua Senha" formControlName="senha" maxlength="50">

                <div *ngFor="let error of formErrors.senha" class="alert alert-danger">
                  {{ error }}
                </div>

              </div>
            </div>
          </div>
          <!--/.row-->
          <div class="row" *ngIf="this.useRecaptcha">
            <div class="col-sm-12 section-block small-text" style="font-size: 11px;">
              <re-captcha (resolved)="resolved($event)" siteKey="{{ recaptcha }}"></re-captcha>
            </div>
          </div>          
          <div class="row">
            <div class="col-6">
              <button class="btn btn-bluelight"  [disabled]="!validRecaptcha || !loginForm.valid" 
                      data-toggle="tooltip" data-placement="top" title="Entrar">
                Entrar
              </button>         
           </div>
           <br>            
            <div class="col-6">
              <a routerLink="/consumidor/recuperar_senha" style="cursor: pointer;">Esqueceu sua senha?</a>
            </div>
          </div>
          
          <div class="d-flex justify-content-center">                                    
            <div class="col-6">
                <button type="button" class="btn btn-graylight" (click)="RedirectToGovBr()">
                  Entrar com <img src="assets/images/govbr-colorido-b.png" alt="gov.br" style="min-width: 50px; min-height: 10px; max-width: 23%; display: inherit; margin: 0px 1px;"/>
                </button>         
            </div>
          </div>  

          <!--/.row-->
        </div>
      </div>
    </div>
    <!--/.col-->
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-login/consumidor-login.component.html